__turbopack_context__.v({
  "content": "UltracareInfoSection-module__QT542G__content",
  "imgContainer": "UltracareInfoSection-module__QT542G__imgContainer",
  "root": "UltracareInfoSection-module__QT542G__root",
  "textContainer": "UltracareInfoSection-module__QT542G__textContainer",
});
